import { App as CapacitorApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { registerWithNativePlugin } from "./qaPush.js";

export const ORDINARY_ANDROID_PACKAGE = "ru.axonleads.app";
const API_BASE_URL = (
  import.meta.env.VITE_AXON_API_BASE_URL
  || (import.meta.env.DEV ? "http://127.0.0.1:8000" : "https://api.axonleads.ru")
).replace(/\/$/, "");

export function isOrdinaryPackage(platform, isNative, appId) {
  return isNative && platform === "android" && appId === ORDINARY_ANDROID_PACKAGE;
}

export async function isOrdinaryAndroidApp() {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "android") return false;
  try {
    const info = await CapacitorApp.getInfo();
    return isOrdinaryPackage(Capacitor.getPlatform(), true, info.id);
  } catch {
    return false;
  }
}

export function nativeTestPushTapPath(data) {
  return data?.kind === "axon_native_push_test_v1" && data?.route === "/today"
    ? "/today"
    : null;
}

async function nativeTestRequest(idToken, method, body) {
  const response = await fetch(`${API_BASE_URL}/v1/notifications/native-test-device`, {
    method,
    headers: {
      Authorization: `Bearer ${idToken}`,
      ...(body ? { "Content-Type": "application/json" } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
    cache: "no-store",
    credentials: "omit",
    redirect: "error",
    referrerPolicy: "no-referrer",
  });
  if (!response.ok) {
    throw new Error(response.status === 403
      ? "Тестовое уведомление доступно только выбранному тестовому аккаунту."
      : method === "GET"
        ? "Не удалось проверить статус уведомления. Попробуйте позже."
        : "Не удалось подключить тестовое уведомление. Попробуйте позже.");
  }
  return response.json();
}

export async function fetchNativeTestPushStatus(idToken) {
  if (!(await isOrdinaryAndroidApp())) {
    throw new Error("Это действие доступно только в Android-приложении AxonLeads.");
  }
  return nativeTestRequest(idToken, "GET");
}

export async function enableNativeTestPush(idToken) {
  if (!(await isOrdinaryAndroidApp())) {
    throw new Error("Это действие доступно только в Android-приложении AxonLeads.");
  }
  try {
    // Only the explicit settings button calls this permission/registration path.
    const token = await registerWithNativePlugin();
    return await nativeTestRequest(idToken, "POST", {
      packageName: ORDINARY_ANDROID_PACKAGE,
      token,
    });
  } catch (error) {
    await PushNotifications.unregister().catch(() => {});
    throw error;
  }
}

export async function disableNativeTestPush(idToken) {
  if (!(await isOrdinaryAndroidApp())) return;
  try {
    if (idToken) await nativeTestRequest(idToken, "DELETE");
  } finally {
    await PushNotifications.unregister().catch(() => {});
  }
}

export async function unregisterNativeTestPush() {
  if (await isOrdinaryAndroidApp()) await PushNotifications.unregister().catch(() => {});
}

export async function addNativeTestPushTapListener(navigate) {
  if (!(await isOrdinaryAndroidApp())) return null;
  return PushNotifications.addListener("pushNotificationActionPerformed", (event) => {
    const path = nativeTestPushTapPath(event?.notification?.data);
    if (path) navigate(path);
  });
}
